exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/address/address.component.scss
// module id = ../../../../../src/app/shared/components/address/address.component.scss
// module chunks = main